var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqlines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 737,
    viewBox: "0 0 522 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.5 1C571.449 1 736 165.551 736 368.5C736 571.449 571.449 736 368.5 736C165.551 736 1 571.449 1 368.5C1 165.551 165.551 1 368.5 1Z",
    stroke: "#FFEF00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.283 558.814C587.534 558.814 706.932 440.049 706.932 294.549C706.932 149.049 587.534 30.0677 441.283 30.0677C295.032 30.0677 175.406 148.832 175.406 294.56C175.406 440.287 294.793 558.825 441.283 558.825V558.814Z",
    stroke: "#00A8E1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.512 706.932C443.21 706.932 562.972 588.168 562.972 442.667C562.972 297.167 443.221 178.175 296.512 178.175C149.803 178.175 30.0625 296.951 30.0625 442.667C30.0625 588.384 149.585 706.932 296.523 706.932H296.512Z",
    stroke: "#FF5C00",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqlines);
export default __webpack_public_path__ + "static/media/faqlines.084e32b7dc8ef34f8aeb0f588ef5d767.svg";
export { ForwardRef as ReactComponent };